module.exports = __webpack_public_path__ + "static/media/lalaRukh_87.77056ab0.jpg";